const Header = {
  init() {
    Header.events();
    Header.toggle();
    Header.sub_menu();
    Header.search();
    Header.mobile();

    $(window).on("resize", () => {
      Header.mobile();
    });
  },

  events() {
    Header.scroll();
    $(window).scroll(function () {
      Header.scroll();
    });
  },

  mobile() {
    if ($(window).width() <= 1250) {
      let height = $("html").offset().top;
      let totalHeight = height + $(".header").height();

      // QCF overlay
      $(".header .qcf").css("top", height);

      // Menu
      $(".header__right").css({
        height: "calc(100vh - " + totalHeight + "px)",
      });
    } else {
      $(".header .qcf").css("top", "");
      $(".header__right").css("height", "");
    }
  },

  toggle() {
    let windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(".header").toggleClass(
        "header--was-scrolled",
        $(".header").hasClass("header--scrolled")
      );
      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    // Toggle dropdown
    $(".languages__toggle").on("click", function (e) {
      e.preventDefault();
      let btn = $(this);
      btn.toggleClass("languages__toggle-open");
      btn.next().slideToggle(250);
    });
  },

  sub_menu() {
    // Submenu functionality
    $(".menu-item__toggle-submenu").on("click", function (e) {
      e.preventDefault();
      let btn = $(this);
      let menuItem = btn.closest(".menu-item");
      let siblings = menuItem.siblings();

      menuItem.toggleClass("menu-item--submenu-open");
      menuItem.find(".sub-menu").slideToggle(250);

      siblings.children(".sub-menu").slideUp(250);
      siblings.removeClass("menu-item--submenu-open");

      if ($(".menu-item--submenu-open").length) {
        $("html").addClass("no-scroll");
      } else {
        $("html").addClass("no-scroll");
      }
    });
  },

  search() {
    $(".search__toggle").click(function (e) {
      if (!$(".search-wrap.active").length) {
        e.preventDefault();
        $(".search-wrap").addClass("active");
        $(".search__input").focus();

        if (window.innerWidth > 900) {
          $(".main-nav").addClass("hidden");
        }
      }
    });

    $(".search__clear").click(function (e) {
      e.preventDefault();
      $(".search__input").val("").focus();
    });

    // Close active search if ESCAPE pressed
    $(document).on("keydown", function (e) {
      if ((e.keyCode === 27) && (window.innerWidth > 900) && ($(".search-wrap").hasClass("active"))) {
        $(".search__input").val("");
        $(".search-wrap").removeClass("active");
        $(".main-nav").removeClass("hidden");
      }
    });

    // Close active search if clicked outside of search
    $(document).on("click", function (e) {
      if ($(".search-wrap.active").length) {
        if ((window.innerWidth > 900) && (!$(e.target).closest(".search-wrap.active").length)) {
          $(".search__input").val("");
          $(".search-wrap").removeClass("active");
          $(".main-nav").removeClass("hidden");
        }
      }
    })

    $(".search").submit(function (e) {
      e.preventDefault();
      const keyword = $(".search__input").val().trim();
      if (keyword) {
        window.location.href = `/?s=${encodeURIComponent(keyword)}`;
      } else {
        alert("Please enter a search keyword.");
      }
    });

    $(".search__input").keypress(function (e) {
      if (e.which === 13) {
        e.preventDefault();
        $(".search").submit();
      }
    });
  },

  scroll() {
    let st = $(window).scrollTop();
    if (st > 110) {
      $(".header").addClass("header--scrolled");
    } else {
      $(".header").removeClass("header--scrolled");
    }
  },
};
export default Header;
